export default {
	"c3e9fc606eca1c9128640e2195cb847e": "已有签约订单",
	"13ad634c1fdc07c7608baccb98aac1f9": "您已签约先学后付订单，请前往订单详情，查看详细内容。",
	"e4bf091c606d1454ac658f0488399f77": "前往订单详情查看"
}
